import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { RequiresAuthenticatedUser } from '../RequiresAuthenticatedUser';
import { focusOnFirstComponent } from '../common/focusOnFirstComponent';
import InternetBankingActions from '../../actions/InternetBankingActions';
import SiteHeaderActionCreator from '../../actions/SiteHeaderActionCreator';
import AppStore from '../../stores/AppStore';
import SessionStore from '../../stores/SessionStore';
import UserManagementStore from '../../stores/UserManagementStore';
import InternetBankingContentStore from '../../stores/InternetBankingContentStore';
import envConfig from '../../../static/config';
import StringConstant from '../../constants/StringConstants';
import StatementsPreferencesActionCreator from '../../actions/StatementsPreferencesActionCreator';
import AccountsStore from '../../stores/AccountsStore';
import { getNavigationUrl } from '../../actions/getNavigationUrl';
import PathUtils from '../../utils/PathUtils';

class CommsHubLandingPage extends Component {
  constructor(props) {
    super(props);
    this.onMessageReceive = this.onMessageReceive.bind(this);
  }

  componentWillMount() {
    window.addEventListener('message', this.onMessageReceive);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    focusOnFirstComponent(this.refs.accessH1ID);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.onMessageReceive);
  }

  onMessageReceive(event) {
    switch (event.data) {
      case 'goToSecureMessages':
        this.props.history.push(PathUtils.getPageUrl('securemessage'));
        break;
      case 'goToMyDocuments':
        this.props.history.push(PathUtils.getPageUrl('my-documents'));
        break;
      case 'goBackToAccount':
        InternetBankingActions.navigateToWebTask(StringConstant.WEB_HOMEPAGE);
        break;
      case 'newMessagePage':
        const modalConfig = {
          displayLeavePopup: true,
          title: this.props.content.leaveMessageUsTitle,
          body: this.props.content.leaveMessageUsBody,
          secondaryButtonText: this.props.content.leaveModalSecondaryButtonText,
          primaryButtonText: this.props.content.leaveMessageUsPrimaryButtonText,
        };
        SiteHeaderActionCreator.setModalConfig(modalConfig);
        break;
      case 'clearNewMessagePage':
        const modalConfigClear = {
          displayLeavePopup: false,
        };
        SiteHeaderActionCreator.setModalConfig(modalConfigClear);
        break;
      case 'goToPreferences':
        StatementsPreferencesActionCreator.setBackPageReference(
          'WEB-DOCUMENT-LIBRARY'
        );
        InternetBankingActions.navigateToWebTask('WEB-STATEMENTS-PREFERENCES');
        break;
      default:
        if (
          typeof event.data === 'string' &&
          event.data.includes('goToDigitalStatements')
        ) {
          const accountId = event.data.split('/')[1];
          AccountsStore.setAccountID(accountId);
          getNavigationUrl('WEB-DOCUMENT-LIBRARY');
          InternetBankingActions.navigateToWebTask('WEB-DIGITAL-STATEMENTS');
        } else if (event.data && event.data.type === 'resize') {
          const scroll_height = event.data.height;
          document.getElementById(
            'commsHub'
          ).style.height = `${scroll_height}px`;
        }
        break;
    }
  }

  render() {
    const accessToken = SessionStore.getURLTokenValue();
    const baseURL =
      this.props.webTask === 'WEB-DOCUMENT-LIBRARY'
        ? envConfig.documentLibraryURL
        : envConfig.secureMessageURL;
    const srcURL =
      `${baseURL}&isDocumentLibraryEnabled=${envConfig.isDocumentLibraryEnabled}`
        .replace('{user_tracking_id}', AppStore.getUserTrackingID())
        .replace(/{bank_id}/g, SessionStore.getSessionBankID())
        .replace('{access_token}', accessToken)
        .replace('{bankId}', envConfig.brandId)
        .replace(/{brandId}/g, envConfig.brandId)
        .replace(
          '{client_context}',
          InternetBankingContentStore.get('documentTitle')
        )
        .replace('{state}', envConfig.device_name)
        .replace('{is_sme}', UserManagementStore.isSMEUser());
    return (
      <div id="page" className="bow page sm-page">
        <Helmet
          title={
            envConfig.isDocumentLibraryEnabled
              ? this.props.content.communicationsHub
              : this.props.content.secureMessages
          }
        />
        <div className="sm-container">
          <iframe
            id="commsHub"
            className="comms-hub-iframe"
            scrolling="no"
            width="100%"
            frameBorder="0"
            src={srcURL}
          />
        </div>
      </div>
    );
  }
}
CommsHubLandingPage.propTypes = {
  isSMEUser: PropTypes.bool,
  history: PropTypes.object,
  content: PropTypes.shape({
    communicationsHub: PropTypes.string,
    secureMessages: PropTypes.string,
    leaveMessageUsTitle: PropTypes.string,
    leaveMessageUsBody: PropTypes.string,
    leaveModalSecondaryButtonText: PropTypes.string,
    leaveMessageUsPrimaryButtonText: PropTypes.string,
  }),
  webTask: PropTypes.oneOf(['WEB-DOCUMENT-LIBRARY', 'WEB-SECURE-MESSAGE']),
};

export default RequiresAuthenticatedUser(CommsHubLandingPage);
